import { useTranslation } from 'react-i18next';
import { capitalize } from 'utils';

import s from '../../styles.module.scss';

import type { IPatientHoldingStatus } from 'infrastructure/interfaces';
import type { FC } from 'react';

interface HoldingStatusBadgeProps {
  remainingDays: number;
  holdingStatus: IPatientHoldingStatus;
}

const HoldingStatusBadge: FC<HoldingStatusBadgeProps> = ({
  remainingDays,
  holdingStatus,
}) => {
  const { t } = useTranslation();

  return (
    <div data-cy="holding-status-tag" className={s.badge}>
      <p>
        {capitalize(holdingStatus.status)}: {remainingDays + 1}{' '}
        {remainingDays < 1 ? t('labels.day') : t('labels.days')}
      </p>
    </div>
  );
};
export default HoldingStatusBadge;
